import axios from '@/utils/axios_iface'
import { Num } from '@/helpers/Math'

const state = {
  selectedAddress: undefined,
  addressToEdit: null,
  map_details: false,
  loyalty_amount: 0,
  loyalty_points: 0,
  userStreet: {
    nearest_landmark: '',
    street: '',
    building: '',
    flat_number: '',
    lat_lng_available: false,
    location_coordinates: { lat: 0, lng: 0 },
  },
}
const actions = {
  async createNewAddress({ getters }, payLoad) {
    return axios.post(getters.create_customer_address_url, payLoad)
  },
  async editCustomerAddress({ getters }, payLoad) {
    return axios.post(getters.edit_customer_address_url, payLoad)
  },
  async deleteCustomerAddress({ getters }) {
    return axios.post(getters.delete_customer_address_url)
  },
  setAddressToEdit: ({ commit }, id) => commit('SET_ADDRESS_TO_EDIT', id),
  mapDetails({ commit, getters, state }, order) {
    if (order) {
      let customerAddress = getters.get_address_by_area_id(
        order.order_delivery_area
      )
      if (!customerAddress) {
        customerAddress = state.selectedAddress
        /*customerAddress = {
          building: order.order_building || '',
          delivery_area_id: order.order_delivery_area_id || '',
          flat_number: order.order_flat_number || '',
          street: order.order_street || '',
          nearest_landmark: order.order_nearest_landmark || '',
          lat_lng_available: false,
        }*/
      }
      let driverInformation = getters.getDriverInformation
        ? getters.getDriverInformation.rider_data
        : false
      let customer_address_label =
        order.order_flat_number +
        ', ' +
        order.order_building +
        ', ' +
        order.order_street +
        ', ' +
        order.order_city
      let storeAddress = getters.find_store_by_main_id(order.store_id)
      let store_address_label =
        getters._T_DB(storeAddress, 'name') +
        ', ' +
        getters._T_DB(storeAddress, 'address') +
        ', ' +
        getters._T_DB(storeAddress, 'city')
      let mapDetails = customerAddress
        ? {
            origin: {
              position: {
                lat: customerAddress.lat_lng_available
                  ? customerAddress.location_coordinates.lat
                  : false,
                lng: customerAddress.lat_lng_available
                  ? customerAddress.location_coordinates.lng
                  : false,
              },
              // this.customer_address has customer address details
              icon: { url: '/images/svg/user-map.svg' },
              data_title: getters.userName || 'User',
              name:
                customer_address_label ||
                'Khalifa City, Abu Dhabi, United Arab Emirates',
            },
            destination: {
              position: {
                lat: storeAddress
                  ? storeAddress.location_coordinates.lat
                  : false,
                lng: storeAddress
                  ? storeAddress.location_coordinates.lng
                  : false,
              },
              // this.all_stores[0], has store location
              icon: { url: '/images/svg/placed.svg' },
              data_title: 'Store',
              name: store_address_label || 'Deira, Dubai, United Arab Emirates',
            },
            driver_position:
              driverInformation &&
              driverInformation.geom &&
              driverInformation.geom.latitude
                ? {
                    position: {
                      lat: driverInformation.geom.latitude,
                      lng: driverInformation.geom.longitude,
                    },
                    icon: { url: '/images/svg/driver.svg' },
                    data_title: driverInformation.rider_name || 'Driver',
                    name: '',
                  }
                : false,
          }
        : false
      commit('MAP_DETAILS', mapDetails)
      return mapDetails
    }
  },
  async contact_us({ getters }, payLoad) {
    return axios.post(getters.contact_us_api_url, payLoad)
  },
  resetCustomerStoreStates({ commit }) {
    commit('RESET_CUSTOMER_STORE_STATES')
  },
  calculateLoyaltyAmountForItem({ commit, getters }) {
    const loyalty_card = getters.customer_current_loyalty_card
    const discount_on_order = getters.discount_on_order
    let loyalty_balance = loyalty_card ? parseFloat(loyalty_card.balance) : 0
    const loyalty = getters.loyalty_programs
    let maxRedeem = getters.currentBrand
      ? parseFloat(getters.currentBrand.maximum_redeem)
      : parseFloat('0')
    let items = getters.cart_items
    // let orderType = getters['order/orderType']
    // let order_type_spend = orderType + '_spend_points'
    let loyalty_items = []
    let amount = 0
    let redeem_point = 0
    let total_of_one_point_redeem = 0
    let total_redeem_amount_for_items = 0
    let loyalty_details_ids = []
    items.forEach(item => {
      if (loyalty && item) {
        let loyalty_action = loyalty.find(loyalty => {
          if (
            loyalty.for_items.includes(item._id) &&
            loyalty['online_spend_points'] === true
          ) {
            return loyalty
          }
        })
        let loyalty_for_item = 0
        let loyalty_apply_on_price = 0
        /*if (!item.price_override == true) {
          loyalty_apply_on_price +=parseFloat(Num.round(item.netPrice)) * item.quantity
        } else {
          loyalty_apply_on_price +=parseFloat(Num.price(item.netPrice)) * item.quantity
        }*/
        // let loyalty_apply_on_price = parseFloat(item.netPrice) * item.quantity
        if (loyalty_action && loyalty_balance > 0.001) {
          if (discount_on_order) {
            loyalty_apply_on_price = parseFloat(
              getters.get_order_discount_item_amount(item)
            )
          } else {
            loyalty_apply_on_price +=
              parseFloat(Num.round(item.value)) * item.quantity
          }
          if (!loyalty_details_ids.includes(loyalty_action._id)) {
            total_of_one_point_redeem = loyalty_action.one_point_redeems_to
          }

          loyalty_details_ids.push(loyalty_action._id)
          let redeem_amount_for_item =
            loyalty_apply_on_price * loyalty_action.one_point_redeems_to
          if (redeem_amount_for_item >= loyalty_apply_on_price) {
            loyalty_for_item =
              loyalty_balance <= loyalty_apply_on_price
                ? loyalty_balance
                : loyalty_apply_on_price
          } else {
            loyalty_for_item =
              loyalty_balance <= redeem_amount_for_item
                ? loyalty_balance
                : redeem_amount_for_item
          }
          total_redeem_amount_for_items += loyalty_for_item

          loyalty_balance -= parseFloat(loyalty_for_item)
          item.loyalty_ammount = loyalty_for_item
          loyalty_items.push(item)
        } else {
          item.loyalty_ammount = 0
          loyalty_items.push(item)
        }
      }
    })
    if (total_redeem_amount_for_items > 0 && loyalty_card.balance > 0) {
      amount =
        total_redeem_amount_for_items <= maxRedeem
          ? total_redeem_amount_for_items
          : maxRedeem
      amount = loyalty_card.balance <= amount ? loyalty_card.balance : amount
      redeem_point = amount / total_of_one_point_redeem
    }
    commit('LOYALTY_INFORMATION', { msg: '', amount: 0 })
    commit('CASHBACK_ON_TRANSACTION', false)
    commit('LOYALTY_AMOUNT', amount)
    commit('LOYALTY_POINTS', redeem_point)
    // commit('CUSTOMER_LOYALTY_ITEM', loyalty_items)
  },
}
const getters = {
  userStreet: state => state.userStreet,
  max_spent_loyalty: (state, getters) => {
    return {
      amount: getters.exchange_price(state.loyalty_amount),
      points: state.loyalty_points,
    }
  },
  current_customer: (state, getters) => {
    if (
      !Array.isArray(getters.customer) &&
      typeof getters.customer === 'object' &&
      getters.customer !== null
    ) {
      return getters.customer
    }
    return {
      item: {
        cards: [],
      },
      collected_data: {
        loyalty_cards: [],
      },
    }
  },
  map_coordinates: state => {
    return state.map_details
  },
  customer_loyalty_cards: (state, getters) =>
    getters.current_customer.collected_data.loyalty_cards,
  customer_current_loyalty_card: (state, getters) => {
    if (getters.currentStore) {
      return getters.customer_loyalty_cards.find(
        card => card.currency == getters.currentStore.currency
      )
    }

    return getters.customer_loyalty_cards[0]
  },
  loyalty_programs: (state, getters) => {
    let store = getters.currentStore
    if (
      store &&
      getters.current_customer.collected_data.page_lookups &&
      getters.current_customer.collected_data.page_lookups
        .brand_loyalty_programs
    ) {
      let brandLoyalties = Object.values(
        getters.current_customer.collected_data.page_lookups
          .brand_loyalty_programs._id
      )
      return brandLoyalties.filter(loyalty => {
        if (
          loyalty.brand_stores.includes(store._id) &&
          loyalty.currency === store.currency
        ) {
          return loyalty
        }
      })
    }
    return false
  },
  loyalty_balance: (state, getters) => {
    const card = getters.customer_current_loyalty_card
    if (card) {
      return Num.round(card.balance)
    }
    return 0
  },
  customer_credit_cards: (state, getters) =>
    getters.current_customer.item.cards || [],

  // getter created for other computation
  customer_address: state => {
    return state.selectedAddress
  },
  get_address_by_area_id: (state, getters) => areaId => {
    return getters.customer_addresses
      ? getters.customer_addresses.find(
          address => address.delivery_area_id === areaId
        )
      : false
  },
  getAddressToEdit: state => state.addressToEdit,
  customer_addresses: (state, getters) => {
    if (getters.current_customer && getters.current_customer.item) {
      return getters.domainBasedBrand
        ? getters.current_customer.item.customer_addresses
        : getters.current_customer.item.go_customer_addresses
    }
    return false
  },
  alex_customer_addresses_by_store_id: (state, getters) => (
    store_id = false
  ) => {
    let storeId = store_id || getters.currentStoreId
    let store = getters.make_slug_to_data('store', store_id)
    if (store) storeId = store._id
    if (getters.customer && getters.customer.collected_data && storeId) {
      var results = getters.customer_addresses.filter(address => {
        var stores = getters.getDAMapForStores[address.delivery_area_id]
        if (stores && stores[storeId]) return stores[storeId]
        var city_da_arr = address.delivery_area_id.split('|')
        var city_da =
          city_da_arr[1] + '|' + city_da_arr[1] + '|' + city_da_arr[2]
        var city_stores = getters.getDAMapForStores[city_da]
        if (city_stores && city_stores[storeId]) return city_stores[storeId]
        return undefined
      })

      return results
    }
    return []
  },
  customer_addresses_by_store_id: (state, getters) => (store_id = false) => {
    let storeId = store_id || getters.currentStoreId
    let store = getters.make_slug_to_data('store', store_id)
    if (store) storeId = store._id
    if (getters.customer && getters.customer.collected_data && storeId) {
      if (
        getters.brand_all_delivery_areas &&
        getters.brand_all_delivery_areas.length
      ) {
        var results = getters.customer_addresses.filter(address => {
          //search in brand delivery areas
          return getters.brand_all_delivery_areas.find(
            bda => bda.delivery_area == address.delivery_area_id
          )
        })
        return results
      }
    }
    return []
  },
  // eslint-disable-next-line no-unused-vars
  deliveryAreaName: (state, getters) => areaId => {
    return areaId ? areaId.split('|').join(', ') : ''
  },
  create_customer_address_url: (state, getters) => {
    const customerId = getters.web_user.id
    if (!getters.domainBasedBrand) {
      return `${getters.goorder_customers_api}/add?parent_id=${customerId}`
    }

    return `${getters.domain_based_customers_api}/add?parent_id=${customerId}`
  },
  edit_customer_address_url: (state, getters) => {
    const customerId = getters.web_user.id
    if (!getters.domainBasedBrand) {
      return `${getters.goorder_customers_api}/id/${getters.getAddressToEdit.$oid}/edit?parent_id=${customerId}`
    }
    return `${getters.domain_based_customers_api}/id/${getters.getAddressToEdit.$oid}/edit?parent_id=${customerId}`
  },
  delete_customer_address_url: (state, getters) => {
    return getters.edit_customer_address_url.replace('edit', 'delete')
  },
  goorder_customers_api: (state, getters) => {
    return `${getters.api_root_url}/model/go_customer_addresses`
  },
  domain_based_customers_api: (state, getters) => {
    return `${getters.api_root_url}/${getters.currentBrandId}/model/customer_addresses`
  },
  formatAddress: (state, getters) => (currentAddress, filterAddress) => {
    var formatedAddress = []
    if (filterAddress) {
      if (currentAddress.delivery_area_id) {
        let deliveryArea = ''
        deliveryArea = getters.deliveryAreaName(currentAddress.delivery_area_id)
          ? getters.deliveryAreaName(currentAddress.delivery_area_id)
          : ''
        if (deliveryArea) formatedAddress.push(deliveryArea)
      }
    }
    if (currentAddress.flat_number)
      formatedAddress.push(getters._T_DB(currentAddress, 'flat_number'))
    if (currentAddress.building)
      formatedAddress.push(getters._T_DB(currentAddress, 'building'))
    if (currentAddress.street)
      formatedAddress.push(getters._T_DB(currentAddress, 'street'))
    if (currentAddress.city)
      formatedAddress.push(getters._T_DB(currentAddress, 'city'))
    return formatedAddress.join(', ')
  },
  formatOrderAddress: (state, getters) => currentAddress => {
    var formatedAddress = []
    if (currentAddress.order_delivery_area) {
      let deliveryArea = ''
      deliveryArea = getters.deliveryAreaName(
        currentAddress.order_delivery_area
      )
        ? getters.deliveryAreaName(currentAddress.order_delivery_area)
        : ''
      if (deliveryArea) formatedAddress.push(deliveryArea)
    }
    if (currentAddress.order_flat_number)
      formatedAddress.push(getters._T_DB(currentAddress, 'order_flat_number'))
    if (currentAddress.order_building)
      formatedAddress.push(getters._T_DB(currentAddress, 'order_building'))
    if (currentAddress.order_street)
      formatedAddress.push(getters._T_DB(currentAddress, 'order_street'))
    if (currentAddress.order_city)
      formatedAddress.push(getters._T_DB(currentAddress, 'order_city'))
    return formatedAddress.join(', ')
  },
}

const mutations = {
  SET_CUSTOMER_SELECTED_ADDRESS: (state, address) => {
    state.selectedAddress = address
  },
  SET_ADDRESS_TO_EDIT: (state, id) => (state.addressToEdit = id),
  SET_USER_STREET: (state, val) => (state.userStreet = val),
  MAP_DETAILS: (state, map_details) => (state.map_details = map_details),
  LOYALTY_AMOUNT: (state, loyalty_amount) =>
    (state.loyalty_amount = loyalty_amount),
  LOYALTY_POINTS: (state, loyalty_points) =>
    (state.loyalty_points = loyalty_points),
  RESET_CUSTOMER_STORE_STATES: state => {
    state.selectedAddress = undefined
    state.addressToEdit = null
    state.map_details = false
  },
}

export default {
  namespaced: false,
  actions,
  getters,
  mutations,
  state,
}
